import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Table from "../Component/Common/Table";
import Pagination from "../Component/Common/Pagination";
import { ReactComponent as TrashIcon } from "../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../assets/icons/EditBtn.svg";
import { OPEN_DIALOGUE } from "../store/dialogue/dialogue.type";
import { warning } from "../util/Alert";
import PageContainer from "../Component/Common/Page";
import PageHeader from "../Component/Common/PageHeader";
import Button from "../Component/Common/Button";
import AddIcon from "@mui/icons-material/Add";
import {
  getCurrency,
  deleteCurrency,
  isDefaultCurrency,
} from "../store/currency/currency.action";
import dayjs from "dayjs";
import CreateCurrency from "../Component/dialogue/CreateCurrency";
import ToggleSwitch from "../Component/Common/ToggleSwitch";

const Currency = (props) => {
  const dispatch = useDispatch();
  const { currency, totalCurrency } = useSelector((state) => state.currency);
  const { dialogueType } = useSelector((state) => state.dialogue);

  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);

  useEffect(() => {
    dispatch(getCurrency({ page, limit: size }));
  }, [dispatch, page, size]);

  useEffect(() => {
    console.log("currency", currency);
    setData(currency);
  }, [currency]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleDeleteContactUs = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            props.deleteCurrency(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const contactUsTable = [
    {
      Header: "NO",
      body: "name",
      Cell: ({ index }) => <span>{(page - 1) * size + index + 1}</span>,
    },

    {
      Header: "Name",
      body: "name",
      Cell: ({ row }) => <span className="text-capitalize">{row?.name}</span>,
    },

    {
      Header: "Symbol",
      body: "symbol",
      Cell: ({ row }) => <span className="text-capitalize">{row?.symbol}</span>,
    },
    {
      Header: "Currency Code",
      body: "currencyCode",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.currencyCode}</span>
      ),
    },
    {
      Header: "Country Code",
      body: "countryCode",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.countryCode}</span>
      ),
    },
    {
      Header: "IS DEFAULT",
      body: "isActive",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isDefault}
          disabled={row?.isDefault === true ? true : false}
          onChange={() => handleIsActive(row)}
        />
      ),
    },
    {
      Header: "CREATE DATE",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.createdAt ? dayjs(row?.createdAt).format("DD MMMM YYYY") : ""}
        </span>
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          <Button
            className="icon-btn"
            startIcon={<EditIcon />}
            onClick={() => handleEdit(row, "currency")}
          />
          <Button
            className="icon-btn"
            startIcon={<TrashIcon />}
            onClick={() => handleDeleteContactUs(row)}
          />
        </div>
      ),
    },
  ];

  const handleOpenNew = (type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleIsActive = (row) => {
    props.isDefaultCurrency(row?._id);
  };

  return (
    <PageContainer className="userPage withdrawal-page">
      {dialogueType === "currency" && <CreateCurrency />}

      <PageHeader heading={"Welcome Admin"} subHeading={"Currency"} />

      <div className="payment-setting-box user-table">
        <div className="row align-items-center mb-2 p-3 ml-1">
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "0px",
                marginTop: "5px",
                padding: "3px",
              }}
            >
              Currency Table
            </h5>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-2 m-sm-0 new-fake-btn d-flex justify-content-end">
            <Button
              className={"rounded"}
              startIcon={<AddIcon />}
              onClick={() => handleOpenNew("currency")}
            >
              New
            </Button>
          </div>
        </div>
        <div className="mt-3">
          <Table
            data={data}
            mapData={contactUsTable}
            noDataMessage="No Currency Found!"
          />
          <div className="mt-3">
            <Pagination
              totalItem={totalCurrency}
              activePage={page}
              pageSize={size}
              onActivePageChange={handlePageChange}
              onPageSizeChange={handleRowsPerPage}
            />
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default connect(null, { deleteCurrency, isDefaultCurrency })(Currency);
